module.exports = __webpack_public_path__ + "df9ba8beb741eccb9c9168bca14c126e.png";